const uniqueArray = function (arrArg) {
    return arrArg.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
    });
};

var RotateIcon = function(options){
    this.options = options || {};
    this.rImg = options.img || new Image();
    this.canvas = document.createElement("canvas");
};
RotateIcon.makeIcon = function(url) {
    return new Promise((resolve, reject) => {
        const rotateIcon = new RotateIcon({url: url});
        rotateIcon.rImg.addEventListener('load', e => {
            rotateIcon.options.width = rotateIcon.options.width || rotateIcon.rImg.width || 60;
            rotateIcon.options.height = rotateIcon.options.height || rotateIcon.rImg.height || 60;
            rotateIcon.canvas.width = rotateIcon.options.width;
            rotateIcon.canvas.height = rotateIcon.options.height;
            rotateIcon.context = rotateIcon.canvas.getContext("2d");
            resolve(rotateIcon)
        });
        rotateIcon.rImg.addEventListener('error', () => {
            reject(new Error(`Failed to load image's URL: ${url}`));
        });
        rotateIcon.rImg.src = rotateIcon.rImg.src || rotateIcon.options.url || '';
    })
};
RotateIcon.prototype.setRotation = function(options){
    var canvas = this.context,
        angle = options.deg ? options.deg * Math.PI / 180:
            options.rad,
        centerX = this.options.width/2,
        centerY = this.options.height/2;

    canvas.clearRect(0, 0, this.options.width, this.options.height);
    canvas.save();
    canvas.translate(centerX, centerY);
    canvas.rotate(angle);
    canvas.translate(-centerX, -centerY);
    canvas.drawImage(this.rImg, 0, 0);
    canvas.restore();
    return this;
};
RotateIcon.prototype.getUrl = function(){
    return this.canvas.toDataURL('image/png');
};

function toRadians(degrees) {
    return degrees * Math.PI / 180;
}

// Converts from radians to degrees.
function toDegrees(radians) {
    return radians * 180 / Math.PI;
}

function bearing(startLat, startLng, destLat, destLng){
    startLat = toRadians(startLat);
    startLng = toRadians(startLng);
    destLat = toRadians(destLat);
    destLng = toRadians(destLng);

    const y = Math.sin(destLng - startLng) * Math.cos(destLat);
    const x = Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
    let brng = Math.atan2(y, x);
    brng = toDegrees(brng);
    return parseInt((brng + 360) % 360);
}

export { uniqueArray, RotateIcon, bearing };